import React, { useState } from "react";

import PortfolioOverview
    from "./PortfolioOverview";

import PortfolioInspectorTable
    from "./PortfolioInspectorTable";

export default function PortfolioInspector(
{
    clickFunction,
	onWorkspaceRequested
})
{
    const [expanded, setExpanded] =
        useState(false);

    const compact =
        window.innerHeight < 900;

    const collapsedHeight =
        compact
            ? 70
            : 170;

    return (

        <div
            style={{
                position: "fixed",

                left: "60px",

                right: "0px",

                bottom:
                    expanded
                        ? 20
                        : 20 - (400 - collapsedHeight),

                height:
                    expanded
                        ? "calc(100vh - 0px)"
                        : "400px",

                display: "flex",
                flexDirection: "column",

                transition:
                    "bottom .45s ease",

                zIndex: 500,
				backgroundColor: expanded ? 'white' : ''
            }}
        >

            {/*====================================================*/}
            {/* Header                                              */}
            {/*====================================================*/}

            <div
                style={{
                    cursor: "pointer"
                }}
                onClick={() =>
                    setExpanded(!expanded)}
            >

                {
                    !compact &&
                    <>
                        <div
                            style={{
                                fontSize: "28px",
                                fontWeight: 700,
                                color: "#1f2937"
                            }}
                        >
                            Portfolio Inspector
                        </div>

                        <div
                            style={{
                                marginTop: "6px",

                                fontSize: "15px",

                                color: "#6b7280"
                            }}
                        >
                            Browse your portfolio hierarchy and investigate AI generated insights.
                        </div>
                    </>
                }

            </div>
			{
			    expanded &&
			    <div
			        onClick={() => setExpanded(false)}
			        style={{
			            height: "40px",

			            display: "flex",
			            alignItems: "center",
			            justifyContent: "center",

			            marginTop: "18px",

						background:
						    "linear-gradient(180deg,#3a4657 0%,#1f2937 45%,#111827 100%)",

			            borderTop:
			                "1px solid #e5e7eb",

			            borderBottom:
			                "1px solid #e5e7eb",

			            cursor: "pointer",

			            transition: ".2s"
			        }}

			      
			    >

			        <div
			            style={{
			                fontSize: "22px",

			                color: "#efefef",

			                fontWeight: 600
			            }}
			        >
			            ⌄
			        </div>

			    </div>
			}

            {/*====================================================*/}
            {/* Portfolio Overview                                  */}
            {/*====================================================*/}

            <div
                style={{
                    marginTop: "24px",

                    cursor: "pointer"
                }}

                onClick={() =>
                    setExpanded(true)}
            >

                <PortfolioOverview
                    clickFunction={clickFunction}
                />

            </div>

            {/*====================================================*/}
            {/* Explorer                                             */}
            {/*====================================================*/}

            {
                expanded &&
                <div
                    style={{
                        flex: 1,

                        marginTop: "24px",

                        minHeight: 0,

                        overflow: "hidden",

                        display: "flex",
                        flexDirection: "column"
                    }}
                >

                    <PortfolioInspectorTable
						onWorkspaceRequested={onWorkspaceRequested}
					/>

                </div>
            }

        </div>

    );
}